// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__VImpz","Error":"Input_Error__gO9CJ"};